module.exports = __webpack_public_path__ + "static/media/randomlo3.0cf511f6.jpg";